import { render, staticRenderFns } from "./newDespesa.vue?vue&type=template&id=485922f5&scoped=true&"
import script from "./newDespesa.vue?vue&type=script&lang=js&"
export * from "./newDespesa.vue?vue&type=script&lang=js&"
import style0 from "./newDespesa.vue?vue&type=style&index=0&id=485922f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485922f5",
  null
  
)

export default component.exports